<div fxLayout="column" fxFill>
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
      <button mat-button [routerLink]="['../..']">
        <mat-icon class="material-icons">keyboard_backspace</mat-icon>
      </button>
      <mat-divider [vertical]="true"></mat-divider>
      <span>{{ 'tourDetails.tourDetails' | translate }}</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <div fxFlex="grow">
    @if ((actionPending$ | async)) {
      <div fxLayout="column" fxFill fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
      </div>
    }

    @if (!(actionPending$ | async) && (tour$ | async); as tour) {
      <div class="main-content">
        <form [formGroup]="tourForm" appReadOnlyWithoutPermission="ROLE_USER" (ngSubmit)="persistTour()">
          <mat-card appearance="outlined" class="content-section base-data">
            <mat-card-title>{{ 'core.coreData' | translate }}</mat-card-title>
            <app-form-base-data [tour]="tour" [formGroup]="tourForm"></app-form-base-data>
          </mat-card>
          <mat-card appearance="outlined" class="content-section details">
            <mat-tab-group>
              <mat-tab [label]="'tourDetails.basicInformation' | translate">
                <app-form-basic-information [formGroup]="tourForm" [tour]="tour"></app-form-basic-information>
              </mat-tab>
              <mat-tab [label]="'core.drivers' | translate">
                <app-form-drivers [tourDate]="tourDate$" [parentForm]="tourForm"></app-form-drivers>
              </mat-tab>
              <mat-tab [label]="'core.remarks' | translate">
                <mat-form-field>
                  <textarea matInput
                    [formControl]="tourForm.get('material')"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="20"
                    cdkAutosizeMaxRows="5"
                  ></textarea>
                </mat-form-field>
              </mat-tab>
              <mat-tab [label]="'core.internalNote' | translate">
                <mat-form-field>
                  <textarea matInput
                    [formControl]="tourForm.get('internalNote')"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="20"
                    cdkAutosizeMaxRows="5"
                  ></textarea>
                </mat-form-field>
              </mat-tab>
              <mat-tab [label]="'tourDetails.constructionSiteDocuments' | translate">
                <app-form-documents [constructionSite]="tour.constructionSite"></app-form-documents>
              </mat-tab>
              <mat-tab [label]="'reminder.reminder' | translate">
                <app-reminder-details [formGroup]="tourForm.get('reminder')"></app-reminder-details>
              </mat-tab>
            </mat-tab-group>
          </mat-card>
          <div fxLayout="row" fxLayoutAlign="end center" class="save-tour">
            <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="accent" type="submit" [disabled]="tourForm.invalid">
              <mat-icon>done</mat-icon>
              {{ 'tourDetails.actions.persist' | translate }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
</div>
